import { atom } from "jotai";
import { v4 as uuidv4 } from "uuid";

import { PatronEditBooking } from "../../../types";
import { currentBookingAtom, pendingRequestGroupAtom } from "../../stores";
import { enterEditableRoundsStepAtom } from "../EnterEditableRoundsStepAtom/enterEditableRoundsStepAtom";

type addNewRoundPayload = {
  player: PatronEditBooking.RoundPlayer;
  bookingIndex?: number;
};

export const addNewRoundAtom = atom(
  null,
  (get, set, payload: addNewRoundPayload) => {
    // @TODO we will ned to ultimately clean up how we guess the round data
    // but before we can do that we need the full add. This is just a stub for now. (and will
    // hopefully be fixed before i even put this pr up.)
    const booking = get(currentBookingAtom);

    const firstRound = booking?.rounds[0];
    if (!firstRound) return;

    if (
      payload.player.id &&
      booking.rounds.some((round) => round.player.id === payload.player.id)
    )
      return;

    if (
      payload.bookingIndex != null &&
      booking.groupCapacity != null &&
      booking.rounds.filter(
        (round) =>
          (round.bookingIndex ?? 0) === payload.bookingIndex &&
          !round.isNonPlayingHost
      ).length >= booking.groupCapacity
    ) {
      return;
    }

    /**
     * We are cloning the transport / rate / course layout etc. settings from our first round for now.
     * These should probably pull player defaults.
     */
    const clonedRound: PatronEditBooking.Round = {
      ...firstRound,
      isOwner: false,
      isNonPlayingHost: false,
      serverId: null,
      localId: uuidv4(),
      index: Math.max(...booking.rounds.map((round) => round.index)) + 1,
      player: payload.player,
    };
    const newRound =
      clonedRound.type === "Golf"
        ? {
            ...clonedRound,
            roundRate: null,
            bookedRate: null,
            bookingIndex: payload.bookingIndex,
          }
        : {
            ...clonedRound,
            rate: null,
            bookingIndex: payload.bookingIndex,
          };
    const newBooking = {
      ...booking,
      rounds: [...booking.rounds, newRound],
    };
    set(currentBookingAtom, newBooking);
    if (!get(pendingRequestGroupAtom)) set(enterEditableRoundsStepAtom, null);
  }
);
